import React from "react";
import PropTypes from "prop-types";

const AboutModal = ({ closeAboutModal, isModalOpen }) => {
  const openClassName = isModalOpen ? "about-modal display-block" : "about-modal display-none";
  return (
   <div className={openClassName}>
    <div className="modal-main">
      <p>
        This Utilities Dashboard offers an overview of the water and wastewater utility landscape worldwide through
        three key metrics: fragmentation, privatisation, and non-revenue water (NRW).<br />
        A utility is defined as any public or private body whose chief activity is the distribution, collection and/or
        treatment of water or wastewater in a particular geographic area.
      </p>
      <p>
        Fragmentation is represented by the total number of water utilities in each country, based on national and
        international sources. While some countries have an easily quantifiable number of utilities, for others we
        relied on close estimates based on our research. Estimated figures are indicated as such within the map. All
        sources used are available in ‘Download this data’. 
      </p>
      <p>
        Privatisation is shown as a percentage of utilities that are either investor-owned, part-privatised or managed
        under concession contracts out of the number of the utilities within our utilities database. Our database
        incorporates all utilities identified by GWI as serving a population of over 50,000 (or 100,000 in Japan and
        China). This is not a measure of population served by private utilities, and other outsourced management
        arrangements such as lease, affermage or O&M contracts.
      </p>
      <p>
        Non-revenue water is a measure of water treated that is not billed (due to leakage, illegal connections,
        metering inaccuracies or free water provision for example), shown as a percentage of total water produced. For
        this dashboard we have relied whenever possible on national NRW data. In countries where no national source is
        available, but where we have collected NRW figures for more than 50% of major utilities, we have calculated an
        average. Whether the source is national or from our database is indicated within the map. All sources used are
        available in ‘Download this data’. Some utilities define NRW in different ways - any divergence from GWI's
        definition is indicated on the relevant utility's profile page.
      </p>
      <p>
        This dashboard is intended as a point of entry into our utilities database, which you can explore using the
        tools on the right or by accessing directly here.<br />
        Our database incorporates all utilities identified by GWI as serving a population of over 50,000 (or 100,000 in
        Japan and China).
      </p>
      <div>
        We classify these utilities according to:
        <ul className="about-modal-list">
          <li>&nbsp;Service scope: utilities can provide retail water and/or wastewater services (service directly to
          customers), bulk water and/or wastewater services (services to retail utilities), as well drainage/stormwater
          services (management of rainwater in a separate network to sewage).</li>
          <li>&nbsp;Ownership type: our dataset distinguishes between four ownership types: public ownership, investor-owned, part-privatised and concession. Utility service providers operating under lease, affermage, management or operations and maintenance contracts are not included.
          Consequently, there may be significant private sector involvement in markets dominated by publicly owned utilities (e.g. France).</li>
        </ul>
      </div>
      <p>
        Local subsidiaries of large, investor-owned multi-utilities (e.g. American Water) have been listed separately,
        as have the individual contracts of private concessionaires. The single exception to this is SABESP in Brazil,
        whose Sao Paulo contracts have been grouped under a single entry.
      </p>
      <div className="button-wrapper">
        <button onClick={closeAboutModal}>
          Close
        </button>
      </div>
    </div>
   </div>
  );
};

AboutModal.propTypes = {
  closeAboutModal: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
};

export default AboutModal;
